import { assertUnreachable } from '@sgme/fp';

import { mapToFxCashForward } from '@/domain/FxCash/FxCashForward/FxCashForward.utils.ts';
import { mapToFxCashNdf } from '@/domain/FxCash/FxCashNdf/FxCashNdf.utils.ts';
import { mapToFxCashSpot } from '@/domain/FxCash/FxCashSpot/FxCashSpot.utils.ts';
import type { WorkspaceForex } from '@/domain/WorkspaceForex/WorkspaceForex.ts';
import type { FxCash } from '@/store/cash/state.ts';

export const mapToCashTile = (savedTile: WorkspaceForex['products']['cash'][number]): FxCash => {
  switch (savedTile.type) {
    case 'FxFwd':
      return mapToFxCashForward(savedTile);
    case 'FxNdf':
      return mapToFxCashNdf(savedTile);
    case 'FxSpot':
      return mapToFxCashSpot(savedTile);

    default:
      return assertUnreachable(savedTile, `Unhandled cash product type: ${(savedTile as FxCash).type}`);
  }
};
